<template>
  <v-btn
    v-tooltip="addCardTooltip"
    fab
    icon
    small
    :disabled="shouldDisableChanges"
    @click.stop="handleClick"
  >
    <slot name="icon" />
    <slot />
  </v-btn>
</template>

<script>
import cardsModel from '@/mixins/cards-model';

export default {
  name: 'AddCardsButton',
  mixins: [
    cardsModel,
  ],
  data() {
    return {
      addCardTooltip: this.$t('components.DashFilterBar.label.addCardTooltip'),
    };
  },
  methods: {
    handleClick() {
      this.$emit('open-library');
    },
  },
};
</script>
